// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j8Z3j21ShSZ6ReY4cqzq {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 25px;
  user-select: none;
}

.va19MRLcmTafEadorkaK {
  background-color: #fefefe55;
  padding: 15px;
}

.va19MRLcmTafEadorkaK, .pp0i0aC0yZJ5S5gKj33P {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.pp0i0aC0yZJ5S5gKj33P {
  align-items: center;
  flex-direction: column;
}

.ELN_zMmknQpD8D9M3e0V {
  position: relative;
  background-color: #fefefe55;
  border-radius: 25px;
  height: 20px;
  width: 200px;
  max-width: 100%;
}

.nj1tqcDGjEDhMUmatw82, .qARpEQOwdvxD2w2mfQfG {
  border-radius: 25px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.eDIob9nJYppWTg7gCoyf {
  position: absolute;
  font-size: 18px;
  line-height: 20px;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  text-align: center;
}

.nj1tqcDGjEDhMUmatw82 {
  background-color: #5555ff;
  width: var(--exp-percent);
  transition: width 0.5s ease-in-out;
}

.qARpEQOwdvxD2w2mfQfG {
  content: var(--hp-percent);
  background-color: #ff5555;
  width: var(--hp-percent);
  transition: width 0.05s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/UI/index.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,mCAAmC;AACrC","sourcesContent":[".UI {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  padding: 25px;\n  user-select: none;\n}\n\n.topBar {\n  background-color: #fefefe55;\n  padding: 15px;\n}\n\n.topBar, .bottomBar {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.bottomBar {\n  align-items: center;\n  flex-direction: column;\n}\n\n.barContainer {\n  position: relative;\n  background-color: #fefefe55;\n  border-radius: 25px;\n  height: 20px;\n  width: 200px;\n  max-width: 100%;\n}\n\n.expBar, .healthBar {\n  border-radius: 25px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.text {\n  position: absolute;\n  font-size: 18px;\n  line-height: 20px;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  text-align: center;\n}\n\n.expBar {\n  background-color: #5555ff;\n  width: var(--exp-percent);\n  transition: width 0.5s ease-in-out;\n}\n\n.healthBar {\n  content: var(--hp-percent);\n  background-color: #ff5555;\n  width: var(--hp-percent);\n  transition: width 0.05s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"UI": `j8Z3j21ShSZ6ReY4cqzq`,
	"topBar": `va19MRLcmTafEadorkaK`,
	"bottomBar": `pp0i0aC0yZJ5S5gKj33P`,
	"barContainer": `ELN_zMmknQpD8D9M3e0V`,
	"expBar": `nj1tqcDGjEDhMUmatw82`,
	"healthBar": `qARpEQOwdvxD2w2mfQfG`,
	"text": `eDIob9nJYppWTg7gCoyf`
};
export default ___CSS_LOADER_EXPORT___;
